// CAT Mock 2 — QA section.
const catMock2Qa = [
  {
    id: 47,
    type: "mcq",
    question: "A shopkeeper marks an article 40% above its cost price and allows a discount of 15% on the marked price. What is his profit percentage?",
    options: [
      "A. 15%",
      "B. 17%",
      "C. 19%",
      "D. 25%"
    ],
    answer: "C"
  },
  {
    id: 48,
    type: "tita",
    question: "Pipe A can fill a tank in 12 hours and pipe B in 18 hours, while pipe C can empty the full tank in 36 hours. If all three are opened together on an empty tank, in how many hours will it be full?",
    answer: "9"
  },
  {
    id: 49,
    type: "mcq",
    question: "If log₂x + log₄x = 6, then x equals:",
    options: [
      "A. 8",
      "B. 16",
      "C. 32",
      "D. 64"
    ],
    answer: "B"
  },
  {
    id: 50,
    type: "tita",
    question: "How many integers from 1 to 100 (both inclusive) are divisible by 3 or by 5, but not by both?",
    answer: "41"
  },
  {
    id: 51,
    type: "mcq",
    question: "Two numbers are in the ratio 3 : 5. If 10 is added to each, the ratio becomes 5 : 7. What is the sum of the original numbers?",
    options: [
      "A. 32",
      "B. 40",
      "C. 48",
      "D. 56"
    ],
    answer: "B"
  },
  {
    id: 52,
    type: "mcq",
    question: "A train 240 m long passes a pole in 12 seconds. How long will it take to cross a bridge 360 m long?",
    options: [
      "A. 18 s",
      "B. 24 s",
      "C. 30 s",
      "D. 36 s"
    ],
    answer: "C"
  },
  {
    id: 53,
    type: "tita",
    question: "Find the compound interest (in ₹) on ₹8,000 at 10% per annum, compounded annually, for 3 years.",
    answer: "2648"
  },
  {
    id: 54,
    type: "mcq",
    question: "If the roots of x² − 5x + k = 0 differ by 3, the value of k is:",
    options: [
      "A. 2",
      "B. 4",
      "C. 6",
      "D. 8"
    ],
    answer: "B"
  },
  {
    id: 55,
    type: "mcq",
    question: "What is the sum of the first 20 terms of the arithmetic progression 3, 7, 11, …?",
    options: [
      "A. 780",
      "B. 800",
      "C. 820",
      "D. 840"
    ],
    answer: "C"
  },
  {
    id: 56,
    type: "tita",
    question: "In how many distinct ways can the letters of the word LEVEL be arranged?",
    answer: "30"
  },
  {
    id: 57,
    type: "mcq",
    question: "A bag contains 5 red and 3 blue balls. Two balls are drawn at random without replacement. What is the probability that both are red?",
    options: [
      "A. 5/14",
      "B. 5/16",
      "C. 25/64",
      "D. 3/7"
    ],
    answer: "A"
  },
  {
    id: 58,
    type: "mcq",
    question: "What is the area of a triangle whose sides are 13 cm, 14 cm and 15 cm?",
    options: [
      "A. 72 cm²",
      "B. 84 cm²",
      "C. 90 cm²",
      "D. 96 cm²"
    ],
    answer: "B"
  },
  {
    id: 59,
    type: "tita",
    question: "Find the curved surface area (in cm²) of a right circular cylinder of radius 7 cm and height 10 cm. (Take π = 22/7.)",
    answer: "440"
  },
  {
    id: 60,
    type: "mcq",
    question: "What is the remainder when 7^100 is divided by 5?",
    options: [
      "A. 1",
      "B. 2",
      "C. 3",
      "D. 4"
    ],
    answer: "A"
  },
  {
    id: 61,
    type: "mcq",
    question: "A 40-litre mixture contains milk and water in the ratio 3 : 1. How many litres of water must be added to make the ratio 3 : 2?",
    options: [
      "A. 5",
      "B. 8",
      "C. 10",
      "D. 12"
    ],
    answer: "C"
  },
  {
    id: 62,
    type: "tita",
    question: "Two runners start together from the same point on a 400 m circular track and run in opposite directions at 6 m/s and 4 m/s. After how many seconds will they meet for the first time?",
    answer: "40"
  },
  {
    id: 63,
    type: "mcq",
    question: "How many zeros are there at the end of 100! (100 factorial)?",
    options: [
      "A. 20",
      "B. 22",
      "C. 24",
      "D. 25"
    ],
    answer: "C"
  },
  {
    id: 64,
    type: "mcq",
    question: "If f(x) = 2x + 3 and g(x) = x² − 1, then f(g(3)) equals:",
    options: [
      "A. 17",
      "B. 19",
      "C. 21",
      "D. 23"
    ],
    answer: "B"
  },
  {
    id: 65,
    type: "tita",
    question: "The average of six numbers is 15. When one number is removed, the average of the remaining numbers is 14. What number was removed?",
    answer: "20"
  },
  {
    id: 66,
    type: "mcq",
    question: "A boat's speed in still water is 15 km/h and the speed of the stream is 3 km/h. How long will the boat take to go 36 km downstream and return to the starting point?",
    options: [
      "A. 4 h",
      "B. 4.5 h",
      "C. 5 h",
      "D. 6 h"
    ],
    answer: "C"
  },
  {
    id: 67,
    type: "mcq",
    question: "How many integers x satisfy |2x − 5| < 7?",
    options: [
      "A. 5",
      "B. 6",
      "C. 7",
      "D. 8"
    ],
    answer: "B"
  },
  {
    id: 68,
    type: "tita",
    question: "A salary is first increased by 20% and then decreased by 20%. By what percentage has the salary decreased overall? (Enter the number only.)",
    answer: "4"
  }
];

export default catMock2Qa;
